import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserPhoneNumberForm } from "Bands/components";
import { editUserPhoneNumber, userPhoneNumberSelectorCreator } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons, IPhoneNumber } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Phone } from "shared/assets/icons";

const { userPhoneNumber: phoneCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserPhoneNumberModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const phoneIdSelector = useMemo(() => userPhoneNumberSelectorCreator(id), [id]);
  const phone = useSelector(phoneIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IPhoneNumber) => {
    dispatch(editUserPhoneNumber({ id, data }));
  };

  return (
    <UserEntityModal
      defaultValues={phone}
      title={phoneCopy.edit.title}
      icon={Phone}
      action={USER_ACTIONS.editUserPhoneNumber}
      buttons={buttons}
      successMessage={phoneCopy.messages.edited}
      Component={UserPhoneNumberForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
